import { memo, useEffect, Suspense } from "react";
import { Canvas } from "@react-three/fiber";
import ShaderObject from "../ShaderObject";
import useCapture from "use-capture";
import CrystalBall from "./CrystalBall";
import Post from "./Post";

const Experience = ({ isPlaying, setIsPlaying, features }) => {
  const [bind, startRecording] = useCapture({ duration: 15, fps: 60 });

  useEffect(() => {
    if (isPlaying && features.recording.video) {
      startRecording();
    }
  }, [isPlaying, startRecording, features.recording.video]);

  return (
    <>
      <Canvas
        id="fxhash-canvas"
        shadows
        camera={{ position: [0, 0, 12], fov: 50 }}
        perfornace={{
          min: 0.2,
        }}
        dpr={[1, 2]}
        gl={{
          preserveDrawingBuffer: true,
        }}
        onCreated={bind}
        // dpr={Math.min(window.devicePixelRatio, 2)}
      >
        <Suspense fallback={null}>
          <ambientLight intensity={1} />
          <color attach="background" args={[features.palette.bg]} />
          <ShaderObject features={features} />
          <CrystalBall
            features={features}
            isPlaying={isPlaying}
            setIsPlaying={setIsPlaying}
          />
          <Post sacred={features.sacred} factor={features.fluidity} />
        </Suspense>
      </Canvas>
    </>
  );
};

export default memo(Experience);
